import { lazy } from "react"

const PartyConfigPage$$__react__lazy__component = lazy(() => 
    import("./PartyConfigPage__original__module.mjs")
        .then(module => module.get_$$PartyConfigPage$$PartyConfigPage$$react__component$$iqz78bvnujnu())
        .then(component => ({ default: component }))
)

export const get_$$PartyConfigPage$$PartyConfigPage$$react__component$$iqz78bvnujnu = () => PartyConfigPage$$__react__lazy__component